import { Suspense, lazy, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Loader from "./components/common/Loader";
import routes from "./routes";
import Home from "./pages/Home";
import LoginPage from "./pages/Login";
import { menusFilter } from "utils";
import useRole from "hooks/useRole";
import PageNotFound from "pages/PageNotFound";
import FileUploadPage from "components/common/DropFiles";
import UsersList from "components/adminStartup/UsersManagement/userList";
import UserActivityTracker from "components/common/UserActivityTracker";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import Dashboard from "./pages/Dashboard";
import UsersManagement from "./pages/UsersManagement";
import Submissions from "./pages/Submissions";
import Messages from "./pages/Messages";
import Settings from "./pages/Settings";
import Assistance from "./pages/Assistance";
import Explanations from "./pages/Explanations";

const DefaultLayout = lazy(() => import("./layout/DefaultLayout"));

function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const role = useRole();

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerClassName="overflow-auto"
      />
      {role === "student" && <UserActivityTracker />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />

        {/* <Route
          path="/file"
          element={<FileUploadPage onSend={(files: File[]) => {}} />}
        /> */}
        <Route element={<DefaultLayout />}>
          {menusFilter(routes, role).map((route, index) => {
            const { path, component: Component } = route;
            return (
              <Route
                key={index}
                path={path}
                element={
                  <Suspense fallback={<Loader />}>
                    <Component />
                  </Suspense>
                }
              />
            );
          })}
          <Route path="/users/list" element={<UsersList />} />
          {/* Routes explicites pour éviter les problèmes de filtrage par rôle */}
          <Route
            path="/dashboard"
            element={
              <Suspense fallback={<Loader />}>
                <Dashboard />
              </Suspense>
            }
          />
          <Route
            path="/users-management"
            element={
              <Suspense fallback={<Loader />}>
                <UsersManagement />
              </Suspense>
            }
          />
          <Route
            path="/submissions"
            element={
              <Suspense fallback={<Loader />}>
                <Submissions />
              </Suspense>
            }
          />
          <Route
            path="/messages"
            element={
              <Suspense fallback={<Loader />}>
                <Messages />
              </Suspense>
            }
          />
          <Route
            path="/settings"
            element={
              <Suspense fallback={<Loader />}>
                <Settings />
              </Suspense>
            }
          />
          <Route
            path="/assistance"
            element={
              <Suspense fallback={<Loader />}>
                <Assistance />
              </Suspense>
            }
          />
          <Route
            path="/explanations"
            element={
              <Suspense fallback={<Loader />}>
                <Explanations />
              </Suspense>
            }
          />
        </Route>

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
